import type { CSSProperties } from 'react';
import type { Theme } from '@mui/material';
import type { ColorKey } from '../color';

export const createBorder = (theme: Omit<Theme, 'mixins'>) =>
  function border(
    color: ColorKey,
    width: number | string = 1,
    style: CSSProperties['borderStyle'] = 'solid',
    options?: {
      /**
       * `true`일 경우 box-shadow 형태로 표현합니다. (inset 0 0 0 {width} {color})
       *
       * 단. 이 경우 `style` 옵션은 무시됩니다. (box-shadow는 `solid` 형태로만 표현됨)
       */
      asBoxShadow?: boolean;
    },
  ): string {
    const { asBoxShadow } = options ?? {};

    const borderWidth = typeof width === 'number' ? `${width}px` : width;
    const borderColor = theme.color[color] || color;

    if (asBoxShadow) {
      return `inset 0 0 0 ${borderWidth} ${borderColor}`;
    }
    return `${borderWidth} ${style} ${borderColor}`;
  };
